export default "__VITE_ASSET__fUUROVxg__"